var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 0H2.66699C2.13656 0 1.62785 0.210714 1.25278 0.585786C0.877706 0.960859 0.666992 1.46957 0.666992 2V22C0.666992 22.5304 0.877706 23.0391 1.25278 23.4142C1.62785 23.7893 2.13656 24 2.66699 24H22.667C23.1974 24 23.7061 23.7893 24.0812 23.4142C24.4563 23.0391 24.667 22.5304 24.667 22V2C24.667 1.46957 24.4563 0.960859 24.0812 0.585786C23.7061 0.210714 23.1974 0 22.667 0ZM22.667 22H2.66699V2H22.667V22ZM18.667 12C18.667 12.2652 18.5616 12.5196 18.3741 12.7071C18.1866 12.8946 17.9322 13 17.667 13H7.66699C7.40178 13 7.14742 12.8946 6.95989 12.7071C6.77235 12.5196 6.66699 12.2652 6.66699 12C6.66699 11.7348 6.77235 11.4804 6.95989 11.2929C7.14742 11.1054 7.40178 11 7.66699 11H17.667C17.9322 11 18.1866 11.1054 18.3741 11.2929C18.5616 11.4804 18.667 11.7348 18.667 12Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusVector);
export default __webpack_public_path__ + "static/media/minus-vector.c1054b0ca067da2916aa6048f01b37ea.svg";
export { ForwardRef as ReactComponent };